import { Box, Grid, Rating, Typography } from "@mui/material"
import fileFolder from "../../assets/estate-forms-icon.svg"

interface IProps {
  numForms: number,
}


export const LeadAuthProbate = (props:IProps): JSX.Element => {
  const numForms = props.numForms || 0

  return <div style={{textAlign:"center", alignContent:"center", width:"100%"}}>
    <Typography variant="h1" component="h1" style={{color:"white"}}>
      {numForms !== 0 ? <>Success!</> : <>Hmm...</>}
    </Typography>
    <Typography variant="body1" component="div" style={{color:"white"}}>
      <p style={{fontSize:"1.5rem", fontWeight:800, marginTop:"3rem"}}>
        {numForms !== 0 ? <>We’ve matched your answers with the appropriate packet and have your forms</>
          : <>We’re having a difficult time sorting through a few of your answers</>}
        
      </p>
      {numForms === 0 && <p style={{fontSize:"1rem", fontWeight:800, marginTop:"3rem"}}>
        Please create an account to save your responses so that an Estate Advisor
        can look into your results and get back to you with more info
      </p>}
      <Box sx={{
          background: "url(" + fileFolder + ")", 
          backgroundRepeat:"no-repeat", 
          backgroundPosition:"center", 
          backgroundSize:"contain",
          height:"350px",
          marginTop:"3rem",
          paddingTop:"13rem",
          paddingRight:"1.5rem",
        }}>
        <Typography color="secondary" component="span">
        <Grid container spacing={1}>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{textAlign:"right", fontSize:"3rem", lineHeight:"3rem", fontWeight: 800}}>
              {numForms ? numForms : "?"}
          </Grid>
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6} style={{textAlign:"left", fontSize:"1.5rem", lineHeight:"1.5rem", fontWeight: 800}}>
              Estate<br />
              Forms
          </Grid>
        </Grid>
        </Typography>
      </Box>
      <p style={{fontSize:"1.5rem", fontWeight:800, marginTop:"3rem"}}>
        Join the 14,209+ other families saving hundreds of hours and thousands of dollars by using Atticus
      </p>
      {numForms !== 0 && <p style={{fontSize:"1rem", fontWeight:500, marginTop:"3rem" }}>
        Create an account to access your results
      </p>}
      <div style={{marginTop:"3rem" }}>
        <Rating
          name="simple-controlled"
          value={4.7}
          precision={0.1}
          sx={{color:"#01d9c6"}}
          readOnly={true}
        />
      </div>
      <p style={{marginTop:"0" }}> 
        Rated <b>4.7 out of 5</b> stars by customers like you
      </p>
    </Typography>
  </div>
}

